import React from 'react';
import { Card } from 'react-bootstrap';
import { ReservationDatesImageLoader } from '../../utils/loaders/ReservationDatesImageLoader'

export const ReservationDatesLoader = () => (

  <div id="timeslot-loader" aria-labelledby="left-tabs-example-tab-services" role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
    <div className="floating-cards white-bg container">
      <fieldset>
        <legend className="visuallyhidden">Select a Service</legend>
        <ul id="content-loader" aria-label="Filter by Services" className="list-style row">
          <li className="margin-top-13 col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>

          </li>
          <li className="margin-top-13 col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13 col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13  col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13  col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13 col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13  col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13  col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
          <li className="margin-top-13 col-md-4 col-xs-12">
            <Card.Body className='services-card-body'>
              <Card.Title className="font-size-p2 gotham-xn-medium title-hover" ></Card.Title>
            </Card.Body>
            <Card className='img-responsive-wrapper-loader'>
              <ReservationDatesImageLoader />
            </Card>
          </li>
        </ul>
      </fieldset>
    </div>
  </div>

)


